module.exports = __webpack_public_path__ + "static/media/route-plus-sample-email.365c759e.svg";